import { createAction } from 'redux-actions';

import fetch, {
  Api,
  getExtendedRequestConfig,
  getJson,
  handleError,
  noCacheRequestConfig,
} from './fetch';
import { checkForCachedDataAction, requestAction, secondTimeFormat } from './request';
import { idCreator, metaCreator, payloadCreator } from './creator';

export const getDatasourceStatesAction = createAction('GET_DATASOURCE_STATES', payloadCreator, metaCreator);

export const disconnectServiceAction = createAction('DISCONNECT_SERVICE', payloadCreator, metaCreator);

const deleteParams = {
  method: 'DELETE',
};

export const getDataSourceStates = () => (dispatch) => {
  const id = idCreator();
  const description = `Inspecting connected services at ${secondTimeFormat(new Date())}`;
  const { search } = document.location;
  const s = `${search ? `${search}&` : '?'}n=${new Date().getTime()}`;
  const url = `${Api}/tokens/${s}`;
  return checkForCachedDataAction(requestAction({ id, description }), dispatch)
    .then(() => fetch(url, noCacheRequestConfig))
    .then(handleError)
    .then(getJson)
    .then(states => dispatch(getDatasourceStatesAction({ id, description, data: states })))
    .catch((error) => {
      if (error.response && error.response.status === 403) {
        document.location.reload();
      }
      dispatch(getDatasourceStatesAction({ id, description, error }));
    });
};

export const disconnectDataSource = service => (dispatch) => {
  const id = idCreator();
  const description = `Disconnecting service ${service} at ${secondTimeFormat(new Date())}`;
  const url = `${Api}/tokens/${service}`;
  return checkForCachedDataAction(requestAction({ id, description }), dispatch)
    .then(() => fetch(url, getExtendedRequestConfig({ params: deleteParams })))
    .then(handleError)
    .then(() => {
      dispatch(disconnectServiceAction({ id, description, data: service }));
      return dispatch(getDataSourceStates());
    })
    .catch(error => dispatch(disconnectServiceAction({ id, description, error })));
};

export default getDataSourceStates;
